var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, Symbol.toStringTag, {
  value: 'Module'
});
var breadcrumbs = require('../breadcrumbs.js');
var currentScopes = require('../currentScopes.js');
var integration = require('../integration.js');
var console = require('../utils-hoist/instrument/console.js');
var logger = require('../utils-hoist/logger.js');
var severity = require('../utils-hoist/severity.js');
var string = require('../utils-hoist/string.js');
var worldwide = require('../utils-hoist/worldwide.js');
var INTEGRATION_NAME = 'Console';

/**
 * Captures calls to the `console` API as breadcrumbs in Sentry.
 *
 * By default the integration instruments `console.debug`, `console.info`, `console.warn`, `console.error`,
 * `console.log`, `console.trace`, and `console.assert`. You can use the `levels` option to customize which
 * levels are captured.
 *
 * @example
 *
 * ```js
 * Sentry.init({
 *   integrations: [Sentry.consoleIntegration({ levels: ['error', 'warn'] })],
 * });
 * ```
 */
var consoleIntegration = integration.defineIntegration(function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var levels = new Set(options.levels || logger.CONSOLE_LEVELS);
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      console.addConsoleInstrumentationHandler(function (_ref) {
        var args = _ref.args,
          level = _ref.level;
        if (currentScopes.getClient() !== client || !levels.has(level)) {
          return;
        }
        addConsoleBreadcrumb(level, args);
      });
    }
  };
});

/**
 * Capture a console breadcrumb.
 *
 * Exported just for tests.
 */
function addConsoleBreadcrumb(level, args) {
  var breadcrumb = {
    category: 'console',
    data: {
      arguments: args,
      logger: 'console'
    },
    level: severity.severityLevelFromString(level),
    message: formatConsoleArgs(args)
  };
  if (level === 'assert') {
    if (args[0] === false) {
      var assertionArgs = args.slice(1);
      breadcrumb.message = assertionArgs.length > 0 ? "Assertion failed: ".concat(formatConsoleArgs(assertionArgs)) : 'Assertion failed';
      breadcrumb.data.arguments = assertionArgs;
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }
  breadcrumbs.addBreadcrumb(breadcrumb, {
    input: args,
    level: level
  });
}
function formatConsoleArgs(values) {
  var _worldwide$GLOBAL_OBJ;
  return 'util' in worldwide.GLOBAL_OBJ && typeof worldwide.GLOBAL_OBJ.util.format === 'function' ? (_worldwide$GLOBAL_OBJ = worldwide.GLOBAL_OBJ.util).format.apply(_worldwide$GLOBAL_OBJ, _toConsumableArray(values)) : string.safeJoin(values, ' ');
}
exports.addConsoleBreadcrumb = addConsoleBreadcrumb;
exports.consoleIntegration = consoleIntegration;